var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLogged)?_c('v-row',{staticClass:"fill-height",attrs:{"align-content":"center","justify":"center"}},[_c('v-col',{attrs:{"xs":"12","sm":"8","md":"6","lg":"6"}},[_c('LoginForm',{attrs:{"headerText":_vm.$t('ADMIN_PANEL'),"isError":_vm.lastLoginError,"submitting":_vm.submitting},on:{"submit":_vm.handleLogin}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }